import { mapFieldType } from './mapFieldType';

export const generateInitialValues = (formDetails) => {
  return formDetails.reduce((acc, field) => {
    const fieldType = mapFieldType(field.fieldType);
    const isMultiSelect =
      fieldType === 'select' && field.typeSelection === 'multiple';

    let defaultValue;

    if (field.fieldValue !== undefined && field.fieldValue !== null) {
      if (fieldType === 'checkbox' || isMultiSelect) {
        defaultValue = field.fieldValue.split(',');
      } else {
        defaultValue = field.fieldValue;
      }
    } else {
      defaultValue =
        fieldType === 'birthdate' || fieldType === 'file'
          ? null
          : fieldType === 'checkbox' || isMultiSelect
          ? []
          : '';
    }

    acc[field.fieldLabel] = defaultValue;
    return acc;
  }, {});
};
